import { types } from 'mobx-state-tree';

export const FavoriteTeam = types
    .model('FavoriteTeam', {
        id: types.number,
        name: types.string,
        sportId: types.maybeNull(types.number),
        categoryId: types.maybeNull(types.number),
        teamHasLogo: false,
    })
    .actions((s) => ({}))
    .views((s) => ({}));
